import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const userValidateDataFn = (data) => apiClient.post(`${APP_SSO_URL}api/user/validate-data`, data);

export const useUserValidateDataMutation = () => {
  return useMutation({
    mutationFn: userValidateDataFn,
  });
};
